/* =====================================================================
   Sweetie-Co redesign — shared behaviour for every "SC" section
   Scroll reveals, scoop counter, product gallery, bundles, quantity,
   sticky add-to-cart, cart quantity, About page chapter list.
   Built by Noa & Solene Studio.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__scTheme) return;
  window.__scTheme = true;
  document.documentElement.classList.add('sc-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    var value = (Number(cents) || 0) / 100;
    var fmt = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    var withCommas = function (n, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, '.');
        default: return withCommas(value, 2);
      }
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealObserver = null;
  function initReveal(root) {
    var els = root.querySelectorAll('.sc-reveal:not(.is-in), .sc-reviews__bars:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Scoop counter ---------- */
  function initScale(root) {
    root.querySelectorAll('[data-sc-scale]').forEach(function (demo) {
      if (demo.dataset.scReady) return;
      demo.dataset.scReady = '1';
      var max = parseInt(demo.dataset.max, 10) || 7;
      var ml = parseInt(demo.dataset.ml, 10) || 30;
      var count = Math.min(max, Math.max(1, parseInt(demo.dataset.start, 10) || 1));
      var fill = demo.querySelector('[data-sc-scale-fill]');
      var countEl = demo.querySelector('[data-sc-scale-count]');
      var wordEl = demo.querySelector('[data-sc-scale-word]');
      var mlEl = demo.querySelector('[data-sc-scale-ml]');
      var minus = demo.querySelector('[data-sc-scale-minus]');
      var plus = demo.querySelector('[data-sc-scale-plus]');
      var ticks = demo.querySelectorAll('.sc-scale__tick');
      function render() {
        fill.style.height = 'calc(24px + ' + count + ' * (100% - 48px) / ' + max + ')';
        countEl.textContent = count;
        wordEl.textContent = count === 1 ? 'scoop' : 'scoops';
        mlEl.textContent = (count * ml) + 'ml';
        minus.disabled = count <= 1;
        plus.disabled = count >= max;
        ticks.forEach(function (t) {
          var n = parseInt(t.dataset.n, 10);
          t.classList.toggle('is-active', n === count);
          t.classList.toggle('is-packed', n < count);
        });
      }
      minus.addEventListener('click', function () { if (count > 1) { count--; render(); } });
      plus.addEventListener('click', function () { if (count < max) { count++; render(); } });
      render();
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    root.querySelectorAll('[data-sc-gallery]').forEach(function (gallery) {
      if (gallery.dataset.scReady) return;
      gallery.dataset.scReady = '1';
      var thumbs = gallery.querySelectorAll('[data-sc-thumb]');
      var slides = gallery.querySelectorAll('[data-sc-slide]');
      function show(i) {
        slides.forEach(function (s) {
          var on = s.dataset.scSlide === String(i);
          s.classList.toggle('is-active', on);
          if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
        });
        thumbs.forEach(function (t) {
          var on = t.dataset.scThumb === String(i);
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.scThumb); }); });
    });
  }

  /* ---------- Product buy box: bundles, variants, quantity, totals ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-sc-product]').forEach(function (section) {
      if (section.dataset.scReady) return;
      var box = section.querySelector('[data-sc-buybox]');
      if (!box) return;
      section.dataset.scReady = '1';
      var fmt = box.dataset.moneyFormat;
      var base = parseInt(box.dataset.basePrice, 10) || 0;
      var unit = base;
      var compare = 0;
      var qtyInput = section.querySelector('[data-sc-qty-input]');
      var idInput = section.querySelector('[data-sc-variant-id]');
      var variantSelect = section.querySelector('[data-sc-variant]');
      var bundles = section.querySelectorAll('[data-sc-bundle]');
      var totals = section.querySelectorAll('[data-sc-total]');
      var unitEl = section.querySelector('[data-sc-unit-price]');
      var compareEl = section.querySelector('[data-sc-compare]');
      var addButtons = section.querySelectorAll('[data-sc-add]');
      var addLabels = section.querySelectorAll('[data-sc-add-label]');

      function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
      function selected() {
        for (var i = 0; i < bundles.length; i++) if (bundles[i].checked) return bundles[i];
        return null;
      }
      function setAvailable(ok) {
        addButtons.forEach(function (btn) { btn.disabled = !ok; });
        addLabels.forEach(function (l) { l.textContent = ok ? l.dataset.label : 'Sold out'; });
      }
      function paint() {
        var q = qty();
        var b = selected();
        var total = unit * q, shown = unit, was = compare;
        if (b && b.dataset.mode === 'qty' && b.dataset.override === 'true' && parseInt(b.dataset.qty, 10) === q) {
          total = parseInt(b.dataset.price, 10) || total;
          shown = total;
          was = parseInt(b.dataset.full, 10) || 0;
        }
        totals.forEach(function (t) { t.textContent = formatMoney(total, fmt); });
        if (unitEl) unitEl.textContent = formatMoney(shown, fmt);
        if (compareEl) {
          compareEl.hidden = !(was > shown);
          compareEl.textContent = was > shown ? formatMoney(was, fmt) : '';
        }
        bundles.forEach(function (b) { b.closest('.sc-bundle').classList.toggle('is-checked', b.checked); });
      }
      function applyBundle(b, keepQty) {
        if (b.dataset.mode === 'variant') {
          if (idInput) idInput.value = b.dataset.variant;
          unit = parseInt(b.dataset.price, 10) || unit;
          compare = parseInt(b.dataset.compare, 10) || 0;
          if (!keepQty && qtyInput) qtyInput.value = 1;
        } else {
          if (idInput && idInput.dataset.defaultVariant) idInput.value = idInput.dataset.defaultVariant;
          unit = base;
          compare = 0;
          if (!keepQty && qtyInput) qtyInput.value = b.dataset.qty;
        }
        setAvailable(b.dataset.available !== 'false');
        paint();
      }
      function qtyChanged() {
        var b = selected();
        if (!b || b.dataset.mode === 'qty') {
          var q = qty(), match = null;
          bundles.forEach(function (x) { if (x.dataset.mode === 'qty' && parseInt(x.dataset.qty, 10) === q) match = x; });
          if (match || b) bundles.forEach(function (x) { x.checked = x === match; });
          if (match) setAvailable(match.dataset.available !== 'false');
        }
        paint();
      }

      bundles.forEach(function (b) { b.addEventListener('change', function () { applyBundle(b, false); }); });
      var minus = section.querySelector('[data-sc-qty-minus]');
      var plus = section.querySelector('[data-sc-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, qty() - 1); qtyChanged(); });
      if (plus) plus.addEventListener('click', function () { qtyInput.value = qty() + 1; qtyChanged(); });
      if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = qty(); qtyChanged(); });

      if (variantSelect) {
        var fromSelect = function () {
          var opt = variantSelect.options[variantSelect.selectedIndex];
          unit = parseInt(opt.dataset.price, 10) || unit;
          compare = 0;
          setAvailable(opt.dataset.available === 'true');
          paint();
        };
        variantSelect.addEventListener('change', function () {
          fromSelect();
          if (window.history && window.history.replaceState && section.id === 'sc-product') {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', variantSelect.value);
            window.history.replaceState({}, '', url.toString());
          }
        });
        unit = parseInt(variantSelect.options[variantSelect.selectedIndex].dataset.price, 10) || unit;
      }
      var initial = selected();
      if (initial) applyBundle(initial, true); else paint();

      /* Sticky add-to-cart bar */
      var sticky = section.querySelector('[data-sc-sticky]');
      var mainAdd = section.querySelector('.sc-buy__add');
      if (sticky && mainAdd && 'IntersectionObserver' in window) {
        var footer = document.querySelector('.sc-footer, footer');
        var mainVisible = true, footerVisible = false;
        var apply = function () { sticky.classList.toggle('is-visible', !mainVisible && !footerVisible && mainAdd.getBoundingClientRect().top < 0); };
        new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; apply(); }).observe(mainAdd);
        if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; apply(); }).observe(footer);
      }
    });
  }

  /* ---------- Hero slideshow (background + arch photo together) ---------- */
  function initHero(root) {
    root.querySelectorAll('[data-sc-hero]').forEach(function (hero) {
      if (hero.dataset.scReady) return;
      hero.dataset.scReady = '1';
      var slides = hero.querySelectorAll('[data-sc-hero-slide]');
      var arches = hero.querySelectorAll('[data-sc-hero-arch]');
      var dots = hero.querySelectorAll('[data-sc-hero-dot]');
      var current = hero.querySelector('[data-sc-hero-current]');
      if (slides.length < 2) return;
      var i = 0, timer = null, visible = true;
      var speed = (parseInt(hero.dataset.speed, 10) || 7) * 1000;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var show = function (n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        arches.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) {
          d.classList.remove('is-active');
          if (k === i) { void d.offsetWidth; d.classList.add('is-active'); d.setAttribute('aria-current', 'true'); }
          else d.removeAttribute('aria-current');
        });
        if (current) current.textContent = pad(i + 1);
      };
      var start = function () {
        clearInterval(timer);
        if (reduceMotion) return;
        timer = setInterval(function () { if (visible && !document.hidden) show(i + 1); }, speed);
      };
      dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.dataset.scHeroDot, 10)); start(); }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(hero);
      start();
    });
  }

  /* ---------- Live Judge.me reviews (SC Reviews) ----------
     Reads the reviews Judge.me already prints on the product page
     (its "Review widget" block) and shows them in the SC card design. */
  function readJudgeme(doc) {
    var w = doc.querySelector('.jdgm-rev-widg');
    if (!w) return null;
    var txt = function (el, sel) { var n = el.querySelector(sel); return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; };
    var bars = {};
    doc.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (r) {
      var k = parseInt(r.getAttribute('data-rating'), 10);
      if (k >= 1 && k <= 5) bars[k] = parseInt(r.getAttribute('data-frequency'), 10) || 0;
    });
    var reviews = [];
    w.querySelectorAll('.jdgm-rev').forEach(function (r) {
      var rating = r.querySelector('.jdgm-rev__rating');
      reviews.push({
        score: rating ? parseInt(rating.getAttribute('data-score'), 10) || 0 : 0,
        author: txt(r, '.jdgm-rev__author'),
        title: txt(r, '.jdgm-rev__title'),
        body: txt(r, '.jdgm-rev__body'),
        verified: r.getAttribute('data-verified-buyer') === 'true'
      });
    });
    return {
      avg: parseFloat(w.getAttribute('data-average-rating')) || 0,
      count: parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0,
      bars: bars,
      reviews: reviews
    };
  }

  function paintReviews(box, data) {
    if (!data || !data.count) return;
    var stars = function (n) { var s = ''; for (var k = 0; k < n; k++) s += '★'; return s; };
    box.querySelectorAll('[data-sc-jdgm-avg]').forEach(function (el) { el.textContent = data.avg.toFixed(1); });
    box.querySelectorAll('[data-sc-jdgm-stars]').forEach(function (el) { el.textContent = stars(Math.max(1, Math.round(data.avg))); });
    var label = (box.dataset.text || 'average from [count] reviews').replace('[count]', data.count);
    if (data.count === 1) label = label.replace(/reviews/, 'review');
    box.querySelectorAll('[data-sc-jdgm-text]').forEach(function (el) { el.textContent = label; });
    box.querySelectorAll('[data-sc-jdgm-bar]').forEach(function (row) {
      var n = parseInt(row.getAttribute('data-sc-jdgm-bar'), 10);
      var c = data.bars[n] || 0;
      var fill = row.querySelector('.sc-reviews__fill');
      if (fill) fill.style.width = Math.round(c * 100 / data.count) + '%';
      var last = row.lastElementChild;
      if (last) last.textContent = c;
    });
    var min = parseInt(box.dataset.min, 10) || 1;
    var max = parseInt(box.dataset.count, 10) || 3;
    var picks = data.reviews.filter(function (r) { return r.score >= min && r.body; }).slice(0, max);
    var cards = box.querySelector('[data-sc-jdgm-cards]');
    if (cards && picks.length) {
      cards.textContent = '';
      picks.forEach(function (r, i) {
        var fig = document.createElement('figure');
        fig.className = 'sc-review sc-lift sc-reveal is-in';
        fig.style.setProperty('--sc-delay', (i * 0.1) + 's');
        var st = document.createElement('span');
        st.className = 'sc-rating__stars';
        st.setAttribute('aria-label', r.score + ' out of 5 stars');
        st.textContent = stars(r.score);
        fig.appendChild(st);
        if (box.dataset.titles === 'true' && r.title) {
          var t = document.createElement('span'); t.className = 'sc-review__title'; t.textContent = r.title; fig.appendChild(t);
        }
        var q = document.createElement('blockquote');
        q.className = 'sc-review__quote';
        q.textContent = '“' + r.body + '”';
        fig.appendChild(q);
        var who = document.createElement('figcaption');
        who.className = 'sc-review__who';
        var b = document.createElement('strong'); b.textContent = r.author || 'Customer';
        who.appendChild(b);
        if (r.verified) who.appendChild(document.createTextNode(' · Verified buyer'));
        fig.appendChild(who);
        cards.appendChild(fig);
      });
    }
    var all = box.parentNode.querySelector('[data-sc-jdgm-all]');
    if (all && data.count > picks.length) all.hidden = false;
  }

  function initReviews(root) {
    root.querySelectorAll('[data-sc-jdgm]').forEach(function (box) {
      if (box.dataset.scReady) return;
      box.dataset.scReady = '1';
      var section = box.closest('section') || box.parentNode;
      var app = section.querySelector('[data-sc-jdgm-app]');
      var open = function () { if (app) { app.classList.remove('is-collapsed'); app.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); } };
      section.querySelectorAll('[data-sc-jdgm-all]').forEach(function (b) { b.addEventListener('click', open); });
      section.querySelectorAll('[data-sc-jdgm-write]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (!app) return;
          e.preventDefault();
          open();
          var link = app.querySelector('.jdgm-write-rev-link');
          if (link) setTimeout(function () { link.click(); }, 350);
        });
      });

      /* 1. Judge.me widget on this page (product page) */
      var here = app && readJudgeme(app);
      if (here && here.count) { paintReviews(box, here); return; }

      /* 2. Otherwise read it from the product page (homepage) */
      var url = box.dataset.url;
      if (!url || !window.fetch || !window.DOMParser) return;
      var key = 'sc-jdgm:' + url;
      try {
        var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (cached && Date.now() - cached.t < 600000) { paintReviews(box, cached.d); return; }
      } catch (e) {}
      var load = function () {
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var data = readJudgeme(new DOMParser().parseFromString(html, 'text/html'));
            if (!data) return;
            try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); } catch (e) {}
            paintReviews(box, data);
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '800px 0px' });
        io.observe(box);
      } else load();
    });
  }

  /* ---------- Video reviews row ---------- */
  function initVids(root) {
    root.querySelectorAll('[data-sc-vids]').forEach(function (track) {
      if (track.dataset.scReady) return;
      track.dataset.scReady = '1';
      var autoplay = track.dataset.autoplay === 'true' && !reduceMotion;
      var cards = track.querySelectorAll('[data-sc-vid]');
      var section = track.closest('.sc');
      var prev = section && section.querySelector('[data-sc-vids-prev]');
      var next = section && section.querySelector('[data-sc-vids-next]');
      var step = function (dir) {
        var card = cards[0];
        var w = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var muteOthers = function (except) {
        document.querySelectorAll('[data-sc-vid].is-unmuted').forEach(function (c) {
          if (c === except) return;
          var v = c.querySelector('video'); if (v) v.muted = true;
          c.classList.remove('is-unmuted');
          var sb = c.querySelector('[data-sc-vid-sound]'); if (sb) { sb.setAttribute('aria-pressed', 'false'); sb.setAttribute('aria-label', 'Turn sound on'); }
        });
      };
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.setAttribute('playsinline', '');
        var toggle = card.querySelector('[data-sc-vid-toggle]');
        var sound = card.querySelector('[data-sc-vid-sound]');
        var userPaused = false;
        var sync = function () {
          var playing = !video.paused;
          card.classList.toggle('is-playing', playing);
          if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        };
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        if (toggle) toggle.addEventListener('click', function () {
          if (video.paused) { userPaused = false; video.play().catch(function () {}); }
          else { userPaused = true; video.pause(); }
        });
        if (sound) sound.addEventListener('click', function () {
          var turnOn = video.muted;
          if (turnOn) muteOthers(card);
          video.muted = !turnOn;
          card.classList.toggle('is-unmuted', turnOn);
          sound.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
          sound.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
          if (turnOn && video.paused) { userPaused = false; video.play().catch(function () {}); }
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting && e.intersectionRatio >= 0.6) {
                if (autoplay && !userPaused) video.play().catch(function () {});
              } else if (!video.paused) {
                video.pause();
              }
            });
          }, { threshold: [0, 0.6] }).observe(card);
        }
      });
    });
  }

  /* ---------- Cart quantity (submits the cart form to update) ---------- */
  function initCart(root) {
    root.querySelectorAll('[data-sc-cart]').forEach(function (form) {
      if (form.dataset.scReady) return;
      form.dataset.scReady = '1';
      var timer = null;
      var submitSoon = function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.classList.add('is-updating'); form.submit(); }, 450);
      };
      form.querySelectorAll('.sc-cart__item').forEach(function (item) {
        var input = item.querySelector('[data-sc-cart-qty]');
        var minus = item.querySelector('[data-sc-cart-minus]');
        var plus = item.querySelector('[data-sc-cart-plus]');
        if (!input) return;
        if (minus) minus.addEventListener('click', function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); submitSoon(); });
        if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 0) + 1; submitSoon(); });
        input.addEventListener('change', submitSoon);
      });
    });
  }

  /* ---------- About page chapter list ---------- */
  function initChapters(root) {
    root.querySelectorAll('[data-sc-chapters]').forEach(function (nav) {
      if (nav.dataset.scReady || !('IntersectionObserver' in window)) return;
      nav.dataset.scReady = '1';
      var links = nav.querySelectorAll('a[href^="#chapter-"]');
      var setActive = function (id) {
        links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + id); });
      };
      if (links[0]) links[0].classList.add('is-active');
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(e.target.id); });
      }, { rootMargin: '-35% 0px -55% 0px' });
      links.forEach(function (a) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (target) obs.observe(target);
      });
    });
  }

  /* ---------- Announcement bar: rotate messages ---------- */
  var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false, addEventListener: function () {} };
  function initAnnounce(root) {
    root.querySelectorAll('[data-sc-announce]').forEach(function (bar) {
      if (bar.dataset.scReady) return;
      bar.dataset.scReady = '1';
      var msgs = bar.querySelectorAll('[data-sc-announce-msg]');
      if (msgs.length < 2) return;
      var i = 0, paused = false;
      var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      var rotating = function () { return bar.dataset.mode === 'rotate' || phoneMq.matches; };
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      bar.addEventListener('focusin', function () { paused = true; });
      bar.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || !rotating() || document.hidden) return;
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Header: scroll shadow, menu, dropdowns, search ---------- */
  var headerDocBound = false;
  function closeAll(except) {
    document.querySelectorAll('[data-sc-dropdown][open], [data-sc-search][open], [data-sc-menu][open]').forEach(function (d) {
      if (d !== except) d.open = false;
    });
  }
  function initHeader(root) {
    root.querySelectorAll('[data-sc-header]').forEach(function (header) {
      if (header.dataset.scReady) return;
      header.dataset.scReady = '1';
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      header.querySelectorAll('[data-sc-dropdown], [data-sc-search], [data-sc-menu]').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            closeAll(d);
            var input = d.querySelector('input[type="search"]');
            if (input) setTimeout(function () { input.focus(); }, 50);
          }
          if (d.hasAttribute('data-sc-menu')) document.documentElement.classList.toggle('sc-menu-open', d.open);
        });
      });
      header.querySelectorAll('[data-sc-menu-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var m = btn.closest('[data-sc-menu]');
          if (m) { m.open = false; var s = m.querySelector('summary'); if (s) s.focus(); }
        });
      });
    });
    if (headerDocBound) return;
    headerDocBound = true;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-sc-menu][open], [data-sc-search][open], [data-sc-dropdown][open]');
      if (open) { open.open = false; var s = open.querySelector('summary'); if (s) s.focus(); }
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-sc-dropdown][open], [data-sc-search][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    });
    if (phoneMq.addEventListener) phoneMq.addEventListener('change', function (e) {
      if (!e.matches) document.querySelectorAll('[data-sc-menu][open]').forEach(function (m) { m.open = false; });
    });
  }

  function init(root) {
    initAnnounce(root);
    initHeader(root);
    root = root || document;
    initReveal(root);
    initScale(root);
    initGallery(root);
    initProduct(root);
    initHero(root);
    initVids(root);
    initReviews(root);
    initCart(root);
    initChapters(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('details');
    if (d) d.open = true;
  });
})();